import React, { useState, useEffect, useContext } from 'react';
import Layout from './layout';
import { ENDPOINT, makeDraggable, NetworkCall, ShowNotification } from '../utils/constants'
import "./styles/leaderboard.css"
import { Context } from '../context';
import Axios from 'axios';
export default function LeaderBoard(params) {

    const [data, setData] = useState(null)
    const context = useContext(Context)

    const fetchLeaderBoardData = () => {
        ShowNotification("Loading...", "white", -1)

        Axios.get(ENDPOINT + "/problems/scores")
            .then(res => {
                const { scores } = res.data
                let score_list = []
                for (const [id, data] of Object.entries(scores)) {
                    score_list.push({ ...data, id })
                }
                score_list.sort((a, b) => {
                    return b.points - a.points
                })
                console.log(score_list)
                setData(score_list)
                ShowNotification("", "white", 1)
                context.setLeaderBoardData(score_list)
            })
            .catch(err => {
                ShowNotification("Something went wrong", "red", 10000)
            })
    }

    useEffect(() => {
        if (!context.leaderboardData)
            fetchLeaderBoardData()
        else
            setData(context.leaderboardData)

    }, [])

    return (
        <Layout>
            <div style={{ minHeight: '100vh', width: '100%' }}>
                {
                    data &&
                    <div className="lb-board-wrapper" data-aos="zoom-in" id="lb-board-wrapper">
                        <span>LEADERBOARD</span>
                        {
                            data && data.map(each => {
                                return (
                                    <div className="lb-board-each" key={each.id}>
                                        <img src={each.profile_pic} className="lb-profilepic" />
                                        <span className="lb-name">{each.name}</span>
                                        <span className="lb-points">{each.points}</span>
                                    </div>
                                )
                            })
                        }
                    </div>
                }
            </div>
        </Layout>
    )
}

const sample = {
    "5fabebe139e9843bb48be0fe123": {
        name: "Super man",
        points: 40,
        time: 1605445159362,
        profile_pic: "https://lh3.googleusercontent.com/a-/AOh14Gjq5vyJOsLo98h3uJR9J0C9QFPzZgJ-FVJvCNCz=s96-c"
    },
    "5fabebe139e9843bb48be0fe124": {
        name: "Super man 2",
        points: 30,
        time: 1605445159362,
        profile_pic: "https://lh3.googleusercontent.com/a-/AOh14Gjq5vyJOsLo98h3uJR9J0C9QFPzZgJ-FVJvCNCz=s96-c"
    },
    "5fabebe139e9843bb48be0fe125": {
        name: "Super man 3",
        points: 25,
        time: 1605445159362,
        profile_pic: "https://lh3.googleusercontent.com/a-/AOh14Gjq5vyJOsLo98h3uJR9J0C9QFPzZgJ-FVJvCNCz=s96-c"
    },
    "5fabebe139e9843bb48be0fe126": {
        name: "Super man 4",
        points: 10,
        time: 1605445159362,
        profile_pic: "https://lh3.googleusercontent.com/a-/AOh14Gjq5vyJOsLo98h3uJR9J0C9QFPzZgJ-FVJvCNCz=s96-c"
    },
    "5fabebe139e9843bb48be0fe127": {
        name: "Super man 4",
        points: 10,
        time: 1605445159362,
        profile_pic: "https://lh3.googleusercontent.com/a-/AOh14Gjq5vyJOsLo98h3uJR9J0C9QFPzZgJ-FVJvCNCz=s96-c"
    },
    "5fabebe139e9843bb48be0fe128": {
        name: "Super man 4",
        points: 10,
        time: 1605445159362,
        profile_pic: "https://lh3.googleusercontent.com/a-/AOh14Gjq5vyJOsLo98h3uJR9J0C9QFPzZgJ-FVJvCNCz=s96-c"
    },
    "5fabebe139e9843bb48be0fe129": {
        name: "Super man 4",
        points: 10,
        time: 1605445159362,
        profile_pic: "https://lh3.googleusercontent.com/a-/AOh14Gjq5vyJOsLo98h3uJR9J0C9QFPzZgJ-FVJvCNCz=s96-c"
    },
    "5fabebe139e9843bb48be0fe1299": {
        name: "Super man 4",
        points: 10,
        time: 1605445159362,
        profile_pic: "https://lh3.googleusercontent.com/a-/AOh14Gjq5vyJOsLo98h3uJR9J0C9QFPzZgJ-FVJvCNCz=s96-c"
    },
    "5fabebe139e9843bb48be0fe120ei9": {
        name: "Super man 4",
        points: 10,
        time: 1605445159362,
        profile_pic: "https://lh3.googleusercontent.com/a-/AOh14Gjq5vyJOsLo98h3uJR9J0C9QFPzZgJ-FVJvCNCz=s96-c"
    },
    "5fabebe139e9843bb48be0fe129e3ee3": {
        name: "Super man 4",
        points: 10,
        time: 1605445159362,
        profile_pic: "https://lh3.googleusercontent.com/a-/AOh14Gjq5vyJOsLo98h3uJR9J0C9QFPzZgJ-FVJvCNCz=s96-c"
    },

}